import VerificationFormStyles from "../VerificationFormStyles";

const InsuranceDisclaimer = () => {
  return (
    <VerificationFormStyles>
      <div className="cvf__disclaimer">
        <strong>Disclaimer:</strong> Insurance coverage is not guaranteed and
        must be manually verified by our admissions team. Benefits and costs can
        vary based on your specific plan. We’ll review your coverage and help
        clarify what may be included before treatment begins.
      </div>
    </VerificationFormStyles>
  );
};
export default InsuranceDisclaimer;
